var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useEffect, useMemo, useState } from 'react';
import {
  getSortedRowModel,
  getCoreRowModel,
  useReactTable,

  getExpandedRowModel } from
'@tanstack/react-table';
import { useIsFirstRender } from "../../../CustomHooks";
import { CheckBoxHeader, CheckBoxCell } from "./TableElements";
import { TableHeader } from "./TableHeader";
import { TableBody } from "./TableBody";

const applyForSelection = (
withSelection,
withOutSelection,
enableSelection = false) =>
enableSelection ? withSelection : withOutSelection;

// eslint-disable-next-line comma-spacing, max-statements
const Table = ({
  columns,
  data,
  title,
  footer,
  initialState,
  enableSelection,
  sorting,
  setSorting,
  onSelection,
  subRowsKey,
  draggableRows = false,
  allowEditGroupsWithDnD = true,
  onChange = () => {}
}) => {
  const manualSorting = Boolean(setSorting);
  const [internalSorting, setInternalSortingSorting] = useState(
    (initialState === null || initialState === void 0 ? void 0 : initialState.sorting) || []
  );
  const [rowSelection, setRowSelection] = useState({});
  const [internalData, setInternalData] = useState(data);
  const [sortedChanged, setSortedChanged] = useState(false);
  const isFirstRender = useIsFirstRender();

  useEffect(() => {
    setRowSelection({});
    setInternalData(data);
  }, [data]);

  const memoizedColumns = useMemo(
    () => [
    ...applyForSelection(
      [_objectSpread(_objectSpread({},

      {
        id: 'checkbox-select',
        header: CheckBoxHeader,
        cell: CheckBoxCell
      }), {}, {
        meta: { headerClassName: 'w-0' } })],


      [],
      enableSelection
    ),
    ...columns],

    [columns, enableSelection]
  );

  const sortingState = manualSorting ? sorting : internalSorting;
  const sortingFunction = manualSorting ? setSorting : setInternalSortingSorting;

  const table = useReactTable({
    columns: memoizedColumns,
    manualSorting,
    data: internalData,
    initialState,
    state: _objectSpread({
      sorting: sortingState },
    applyForSelection({ rowSelection }, {}, enableSelection)),

    enableRowSelection: (row) => {var _row$original;return (
        Boolean(enableSelection && !((_row$original = row.original) !== null && _row$original !== void 0 && _row$original.disableRowSelection)));},
    enableSubRowSelection: false,
    onRowSelectionChange: applyForSelection(setRowSelection, () => undefined, enableSelection),
    onSortingChange: sortingFunction,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    getSubRows: (row) => {
      if (subRowsKey) {
        return row[subRowsKey];
      }
      return [];
    }
  });

  useEffect(() => {
    if (isFirstRender) {
      return;
    }

    const sorted = table.
    getRowModel().
    rows.filter((row) => !row.parentId).
    map((row) => row.original);
    onChange(sorted);
    setSortedChanged(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortingState]);

  useEffect(() => {
    const selectedRows = table.getSelectedRowModel().flatRows;
    if (onSelection) {
      onSelection(selectedRows);
    }
  }, [onSelection, rowSelection, table]);

  const handleOnChange = (changedItems) => {
    setSortedChanged(true);
    onChange(changedItems);
  };

  return /*#__PURE__*/(
    _jsx("div", { className: "relative w-full border rounded-md shadow-sm border-gray-50" }, void 0, /*#__PURE__*/
    _jsx("table", { className: "w-full text-sm text-left", "data-testid": "table" }, void 0,
    title && /*#__PURE__*/
    _jsx("caption", { className: "p-4 text-base font-semibold text-left text-gray-900 bg-white" }, void 0,
    title
    ), /*#__PURE__*/


    _jsx("thead", { className: "text-xs text-gray-500 uppercase bg-gray-50" }, void 0,
    table.getHeaderGroups().map((headerGroup) => /*#__PURE__*/
    _jsx(TableHeader, {

      headerGroup: headerGroup,
      draggableRows: draggableRows,
      sortedChanged: sortedChanged }, headerGroup.id
    )
    )
    ), /*#__PURE__*/
    _jsx(TableBody, {
      draggableRows: draggableRows,
      allowEditGroupsWithDnD: allowEditGroupsWithDnD,
      items: data,
      table: table,
      subRowsKey: subRowsKey,
      onChange: handleOnChange }
    )
    ),
    footer && /*#__PURE__*/_jsx("div", { className: "p-4" }, void 0, footer)
    ));

};

export { Table };